(function () {
    'use strict';

    function decimalSearchFieldConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/decimalSearchFieldConfiguration.html',
            link: function (scope) {
            }
        };
    }

    decimalSearchFieldConfiguration.$inject = [];

    angular.module('ecap.common').directive('decimalSearchFieldConfiguration', decimalSearchFieldConfiguration);
})();

